import GenericMenuItem from "./generic/menu-item";
import RoleValidator from "../mixins/models/role-validator";

const Model = GenericMenuItem.extend({
  mixins: [RoleValidator],

  initialize() {
    this.set({
      // keep a copy of original data
      originalData: this.getData(),
    });
  },
});

export { Model as default };
